// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F6vv","title":"styles_title__2ZjpH"};